import React from 'react';
import '../App.css';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Footer from '../components/Footer';
import AOS from "aos";
import "aos/dist/aos.css";
import WelcomeSmall from '../components/WelcomeSmall';
import TextAbout from '../components/TextAbout';

function about() {
  
    AOS.init();
  

  return (
    <div className="App">
      <Header />
      <Menu />
      <WelcomeSmall />
      <TextAbout />
      <Footer/>
    </div>
  );
}

export default about;
